/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import showErrorMessage from '@/util/showErrorMessage';

export default function ValidFileTypeUtil(file) {
  const isValid =
    file.type === 'application/pdf' ||
    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    file.type === 'application/vnd.ms-excel' ||
    file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingm' ||
    file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    file.type === 'application/msword' ||
    file.name?.match(/\.pdf$/) ||
    file.name?.match(/\.doc$/) ||
    file.name?.match(/\.docx$/) ||
    file.name?.match(/\.xls$/) ||
    file.name?.match(/\.xlsx$/) ||
    file.name?.match(/\.msg$/)||
    file.name?.match(/\.xlsm$/);


  if (!isValid) {
    showInvalidFileTypeError();
  }

  return isValid;
}

function showInvalidFileTypeError() {
  showErrorMessage({
    errorCode: 'fileUploadError',
    errorTitle: 'File Type Error',
    errorMessage: 'Please upload a valid file type (.pdf, .doc, .docx, .xls, .xlsx, .xlsm, .msg).'
  });
}
